import { object, string } from "yup";
import { useForm, useFormState } from "react-hook-form";

import Validations from "@helpers/validations";
import useAxios from "@hooks/use-axios";
import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { yupResolver } from "@hookform/resolvers/yup";

const defaultValues = {
    name      : "",
    desc      : "",
    interval  : "",
    operations: {
        operation: "",
        attribute: "",
        value    : 0
    },
    tag                  : "",
    type                 : "",
    rounding             : "",
    value_if_no_attribute: "",
    value_if_no_event    : "",
    visibility_360       : ""
};

const useUpsert = props => {

    const {
        handleModalConfig,
        getHealthScores,
        modalConfig: { row },
        isEdit
    } = props;
    const { platformId } = useParams();
    const { loading, axiosInstance } = useAxios({
        base: "panel"
    });
    const { requiredValidation, numberValidation } = Validations();
    const validationSchema = object().shape({
        name                 : requiredValidation({ name: "Name" }),
        desc                 : requiredValidation({ name: "Description" }),
        interval             : requiredValidation({ name: "Interval" }),
        type                 : requiredValidation({ name: "Type" }),
        rounding             : requiredValidation({ name: "Rounding" }),
        value_if_no_event    : requiredValidation({ name: "Field" }),
        value_if_no_attribute: requiredValidation({ name: "Field" }),
        operations           : object().shape({
            operation: requiredValidation({ name: "Operation" }),
            attribute: requiredValidation({ name: "Attribute" }),
            value    : numberValidation({ name: "Value", min: 0 })
        }),
        tag           : string().optional(),
        visibility_360: requiredValidation({ name: "Visibility 360" })
    });

    const methods = useForm({
        defaultValues,
        resolver: yupResolver(validationSchema)
    });

    const { control, handleSubmit, reset } = methods;
    const { isDirty } = useFormState({ control });

    useEffect(() => {
        let isActive = true;
        if (isEdit && row._id && isActive) {
            reset({
                name                 : row.name,
                desc                 : row.desc,
                interval             : row.interval,
                operations           : row.operations,
                tag                  : row.tag || "",
                type                 : row.type,
                rounding             : String(row.rounding),
                value_if_no_attribute: row.value_if_no_attribute,
                value_if_no_event    : row.value_if_no_event,
                visibility_360       : row.visibility_360
            });
        } else {
            reset(defaultValues);
        }
        return () => {
            isActive = false;
        };
    }, [isEdit, row]);

    const onSubmit = () => {
        handleSubmit(async data => {
            const payload = {
                name      : data.name,
                desc      : data.desc,
                interval  : Number(data.interval),
                operations: {
                    operation: data.operations.operation,
                    attribute: data.operations.attribute,
                    value    : Number(data.operations.value)
                },
                tag                  : data.tag,
                type                 : data.type,
                rounding             : Number(data.rounding),
                value_if_no_attribute: data.value_if_no_attribute,
                value_if_no_event    : data.value_if_no_event,
                visibility_360       : data.visibility_360

            };

            if (row._id) {
                await axiosInstance.patch(
                    `/calculated-metrics/${platformId}/${row._id}`,
                    payload
                );
            } else {
                await axiosInstance.post(`/calculated-metrics/${platformId}`, payload);
            }
            handleModalConfig();
            getHealthScores();
        })();
    };

    return {
        onSubmit,
        methods,
        updateLoading: loading,
        isDirty
    };
};

export default useUpsert;
